import "./App.css";
import React from "react";
import Nav from "./components/Navbar";
import Page from "./components/page";
function App() {
  return (
    <>
      <Nav></Nav>
      <Page></Page>
    </>
  );
}

export default App;
